import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaClipboardList, FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import { devices } from '../data/devices';
import { allTraccarDevices } from '../data/allDevices';
import { EMAIL_CONFIG, EMAIL_TEMPLATE } from '../config/emailConfig';
import monitoramentoImg from '../images/acompanhando-monitoramento.jpg';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    device: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Preparar dados para o email
      const templateParams = {
        user_name: formData.name,
        user_email: formData.email,
        user_phone: formData.phone,
        selected_device: formData.device,
        user_message: formData.message || 'Nenhuma mensagem adicional',
        to_email: EMAIL_CONFIG.TO_EMAIL,
        subject: EMAIL_TEMPLATE.subject
      };

      // Enviar email usando EmailJS
      await emailjs.send(
        EMAIL_CONFIG.SERVICE_ID,
        EMAIL_CONFIG.TEMPLATE_ID,
        templateParams,
        EMAIL_CONFIG.PUBLIC_KEY
      );

      console.log('Email enviado com sucesso!');
      setSubmitted(true);
      
      // Limpar formulário após 3 segundos
      setTimeout(() => {
        setSubmitted(false);
        setFormData({
          name: '',
          email: '',
          phone: '',
          device: '',
          message: ''
        });
      }, 3000);

    } catch (error) {
      console.error('Erro ao enviar email:', error);
      setError('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-info">
          <h2 className="contact-title">Solicite um Orçamento</h2>
          <p className="contact-description">
            Preencha o formulário e nossa equipe entrará em contato para fornecer 
            a melhor solução de rastreamento para suas necessidades.
          </p>

          <div className="contact-benefits">
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div>
                <h4>Atendimento Especializado</h4>
                <p>Consultoria personalizada para seu negócio</p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div>
                <h4>Instalação Profissional</h4>
                <p>Técnicos certificados e experientes</p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div>
                <h4>Suporte Contínuo</h4>
                <p>Assistência técnica sempre que precisar</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-form-wrapper">
          {submitted ? (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h3>Mensagem Enviada!</h3>
              <p>Entraremos em contato em breve.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">
                  <FaUser /> Nome Completo
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Digite seu nome"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  <FaEnvelope /> E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="seu@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">
                  <FaPhone /> Telefone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="(00) 00000-0000"
                />
              </div>

              <div className="form-group">
                <label htmlFor="device">
                  <FaClipboardList /> Dispositivo de Interesse
                </label>
                <select
                  id="device"
                  name="device"
                  value={formData.device}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione um dispositivo</option>
                  <optgroup label="🌟 Dispositivos em Destaque">
                    {devices.map(device => (
                      <option key={device.id} value={device.name}>
                        {device.name} - {device.protocol} (Porta {device.port})
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="📋 Catálogo Completo">
                    {allTraccarDevices
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((device, index) => (
                        <option key={`all-${index}`} value={device.name}>
                          {device.name} - {device.protocol} (Porta {device.port})
                        </option>
                      ))}
                  </optgroup>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensagem (Opcional)</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Conte-nos mais sobre suas necessidades..."
                />
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                <FaPaperPlane />
                {isLoading ? 'Enviando...' : 'Enviar Solicitação'}
              </button>
              
              {error && (
                <div className="error-message">
                  <p>{error}</p>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm;

